module.exports = __webpack_public_path__ + "img/product7.672d7495.png";